module.exports = __webpack_public_path__ + "media/images/new_article_use_icon-35b50789fe470ca5c445ea9d40ba1f1d.png";